(function () {
  "use strict";

  var LEGACY_KEYS = ["kokodress_wish_v1", "kokodress_wish_count_baseline_v1"];
  var configElement = document.querySelector("[data-koko-wishlist-config]");
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent || "{}");
  } catch (_error) {
    return;
  }

  try {
    LEGACY_KEYS.forEach(function (key) { localStorage.removeItem(key); });
  } catch (_error) {
    // The server remains authoritative when storage is unavailable.
  }

  var apiBase = String(config.apiBase || "").replace(/\/$/, "");
  var state = new Map();
  var personalCount = null;
  var refreshTimer = null;

  function productId(button) {
    var value = button && button.getAttribute("data-wish");
    return /^[1-9]\d{0,19}$/.test(value || "") ? value : null;
  }

  function productButtons(id) {
    return Array.from(document.querySelectorAll("[data-wish]")).filter(function (button) {
      return productId(button) === id;
    });
  }

  function renderItem(item) {
    state.set(String(item.productId), item);
    productButtons(String(item.productId)).forEach(function (button) {
      var saved = item.saved === true;
      button.classList.toggle("is-saved", saved);
      button.setAttribute("aria-pressed", String(saved));
      var count = button.querySelector("[data-koko-wish-count], [data-wish-count]");
      if (count) {
        count.textContent = String(item.displayCount);
        var action = saved
          ? (button.dataset.wishRemoveLabel || "Remove from wishlist")
          : (button.dataset.wishAddLabel || "Add to wishlist");
        var accessibleName = action + ", " + item.displayCount + " saves";
        button.setAttribute("aria-label", accessibleName);
      }
    });
  }

  function renderPersonalCount(value) {
    if (!Number.isInteger(value) || value < 0) return;
    personalCount = value;
    var badge = document.querySelector("[data-koko-wishlist-personal-count]");
    var label = document.querySelector("[data-koko-wishlist-personal-label]");
    var link = document.getElementById("wishlist-icon-bubble");
    var accessibleName = value === 1 ? "Wishlist, 1 saved item" : "Wishlist, " + value + " saved items";
    if (badge) {
      badge.textContent = String(value);
      badge.hidden = value === 0;
    }
    if (label) label.textContent = accessibleName;
    if (link) link.setAttribute("aria-label", accessibleName);
  }

  async function refreshPersonalCount() {
    if (!config.loggedIn || !apiBase) return;
    var response = await fetch(apiBase + "/wishlist?limit=1", {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Wishlist count read failed");
    var payload = await response.json();
    renderPersonalCount(Number(payload.total));
  }

  function showToast(message) {
    var toast = document.querySelector("[data-koko-toast]");
    if (!toast) return;
    var messageElement = toast.querySelector("[data-toast-message]");
    if (messageElement) messageElement.textContent = message;
    toast.classList.add("is-show");
    window.clearTimeout(window.kokoWishlistToastTimer);
    window.kokoWishlistToastTimer = window.setTimeout(function () {
      toast.classList.remove("is-show");
    }, 2600);
  }

  function animateFlyToWishlist(button) {
    var target = document.getElementById("wishlist-icon-bubble") || document.querySelector('a[aria-label="Wishlist"]');
    if (!target || !button || typeof button.animate !== "function") return;
    var start = button.getBoundingClientRect();
    var end = target.getBoundingClientRect();
    var flyer = document.createElement("div");
    flyer.className = "wishlist-flyer";
    flyer.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="#8c2f39" stroke="#8c2f39" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    flyer.style.cssText = "position:fixed;z-index:9999;pointer-events:none;left:" + (start.left + start.width / 2 - 10) + "px;top:" + (start.top + start.height / 2 - 10) + "px";
    document.body.appendChild(flyer);
    var animation = flyer.animate([
      { opacity: 1, transform: "scale(1)" },
      { left: (end.left + end.width / 2 - 10) + "px", top: (end.top + end.height / 2 - 10) + "px", opacity: 0, transform: "scale(.5)" },
    ], { duration: 800, easing: "cubic-bezier(.25,1,.5,1)" });
    animation.onfinish = function () {
      flyer.remove();
      target.classList.add("wishlist-pulse");
      window.setTimeout(function () { target.classList.remove("wishlist-pulse"); }, 400);
    };
  }

  async function fetchItems(ids) {
    if (!ids.length || !apiBase) return;
    for (var offset = 0; offset < ids.length; offset += 50) {
      var batch = ids.slice(offset, offset + 50);
      var response = await fetch(apiBase + "/wishlist?product_ids=" + encodeURIComponent(batch.join(",")), {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("Wishlist read failed");
      var payload = await response.json();
      (payload.items || []).forEach(renderItem);
    }
  }

  async function refreshVisible() {
    var ids = Array.from(new Set(Array.from(document.querySelectorAll("[data-wish]")).map(productId).filter(Boolean)));
    await fetchItems(ids);
  }

  function setDisabled(id, disabled) {
    productButtons(id).forEach(function (button) { button.disabled = disabled; });
  }

  async function saveDesiredState(id, saved, sourceButton) {
    var previous = state.get(id);
    if (!previous) return false;
    var optimistic = Object.assign({}, previous, {
      saved: saved,
      savedCount: Math.max(0, previous.savedCount + (saved ? 1 : -1)),
      displayCount: Math.max(previous.baseline, previous.displayCount + (saved ? 1 : -1)),
    });
    renderItem(optimistic);
    setDisabled(id, true);
    if (saved) animateFlyToWishlist(sourceButton);
    try {
      var response = await fetch(apiBase + "/wishlist/products/" + id, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ saved: saved }),
      });
      if (!response.ok) throw new Error("Wishlist write failed");
      var item = await response.json();
      renderItem(item);
      var currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.get("wishlist_add") === id) clearPendingId(currentUrl);
      if (personalCount == null) await refreshPersonalCount().catch(function () {});
      else renderPersonalCount(Math.max(0, personalCount + (saved ? 1 : -1)));
      document.dispatchEvent(new CustomEvent("koko:wishlist-changed", {
        bubbles: true,
        detail: {
          productId: id,
          saved: saved,
          item: item,
          personalCount: personalCount,
        },
      }));
      return true;
    } catch (_error) {
      renderItem(previous);
      showToast("Wishlist is temporarily unavailable. Please try again.");
      return false;
    } finally {
      setDisabled(id, false);
    }
  }

  function loginUrl(id) {
    var returnUrl = new URL(window.location.href);
    returnUrl.searchParams.delete("customer_posted");
    returnUrl.searchParams.set("wishlist_add", id);
    var configured = new URL(String(config.loginUrl || "/customer_authentication/login"), window.location.origin);
    var usesCustomerAuthentication = configured.pathname.indexOf("/customer_authentication/") !== -1;
    var destination = usesCustomerAuthentication
      ? new URL("/customer_authentication/login", configured.origin)
      : configured;
    if (usesCustomerAuthentication) {
      configured.searchParams.forEach(function (value, key) {
        if (key !== "return_to" && key !== "return_url") destination.searchParams.append(key, value);
      });
    }
    destination.searchParams.set("return_to", returnUrl.pathname + returnUrl.search);
    destination.searchParams.delete("return_url");
    return destination.toString();
  }

  function clearPendingId(currentUrl) {
    currentUrl.searchParams.delete("wishlist_add");
    window.history.replaceState({}, "", currentUrl.pathname + currentUrl.search + currentUrl.hash);
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest && event.target.closest("[data-wish]");
    var id = productId(button);
    if (!id) return;
    event.preventDefault();
    event.stopPropagation();
    if (!config.loggedIn) {
      var destination = loginUrl(id);
      var loginEvent = new CustomEvent("koko:wishlist-login-required", {
        bubbles: true,
        cancelable: true,
        detail: { productId: id, loginUrl: destination },
      });
      document.dispatchEvent(loginEvent);
      if (!loginEvent.defaultPrevented) window.location.assign(destination);
      return;
    }
    var current = state.get(id);
    if (current) saveDesiredState(id, current.saved !== true, button);
  });

  async function start() {
    try {
      await refreshVisible();
      if (config.loggedIn) await refreshPersonalCount().catch(function () {});
      var currentUrl = new URL(window.location.href);
      var pendingId = currentUrl.searchParams.get("wishlist_add");
      if (config.loggedIn && pendingId) {
        if (!/^[1-9]\d{0,19}$/.test(pendingId)) {
          clearPendingId(currentUrl);
          return;
        }
        if (!state.has(pendingId)) await fetchItems([pendingId]);
        if (state.get(pendingId)?.saved === true) {
          clearPendingId(currentUrl);
          return;
        }
        var saved = await saveDesiredState(pendingId, true, document.querySelector('[data-wish="' + pendingId + '"]'));
        if (saved) {
          showToast("Saved to your wishlist.");
        }
      }
    } catch (_error) {
      showToast("Wishlist is temporarily unavailable. Please try again.");
    }
  }

  var observer = new MutationObserver(function (mutations) {
    var hasNewButton = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && ((node.matches && node.matches("[data-wish]")) || (node.querySelector && node.querySelector("[data-wish]")));
      });
    });
    if (!hasNewButton) return;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () { refreshVisible().catch(function () {}); }, 50);
  });

  function boot() {
    observer.observe(document.body, { childList: true, subtree: true });
    start();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
}());
